import { computed, reactive } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';

import QUERY_KEYS from '@/constants/queryKeys';

import { claimFlakeService } from '@/services/claim/claim-flake.service';

import { ClaimFlakeStatus } from '@/services/claim/types';

import useWeb3 from '@/services/web3/useWeb3';
import useNetwork from '@/composables/useNetwork';

type UserClaimsFlakeQueryResponse = ClaimFlakeStatus[];

export default function useUserClaimsFlakeQuery(
  farmPids: string[] | [],
  options: UseQueryOptions<UserClaimsFlakeQueryResponse> = {}
) {
  // COMPOSABLES
  const { account, isWalletReady } = useWeb3();
  const { networkId } = useNetwork();

  // DATA
  const queryKey = reactive(QUERY_KEYS.ClaimsFlake.All(networkId, account));

  // COMPUTED
  const enabled = computed(
    () => isWalletReady.value && account.value != null && farmPids.length !== 0
  );

  // METHODS
  const queryFn = async () => {
    const claimFlakeStatus = await claimFlakeService.getClaimFlakeStatus(
      account.value,
      farmPids
    );

    return claimFlakeStatus;
  };

  const queryOptions = reactive({
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });

  return useQuery<UserClaimsFlakeQueryResponse>(
    queryKey,
    queryFn,
    queryOptions
  );
}
